import { ResourceBuilder } from '@salsita-ai/platform-project-sdk/domain';
import { adminDomainBuilder, adminInvariantBuilder } from './__generated/admin-implementation.js';
import { generatedConfiguratorBuilder } from './__generated/configurator-builder.js';
import { domainBuilder, invariantBuilder } from './__generated/implementation.js';
import { migrateAdminState } from './admin-migrations/index.js';
import { applianceExpressions } from './implementations/appliance.js';
import { cabinetExpressions } from './implementations/cabinets.js';
import { cornerFillerExpressions } from './implementations/corner-filler.js';
import { grillExpressions } from './implementations/grills.js';
import { partExpressions } from './implementations/parts.js';
import { roomItemExpressions } from './implementations/room-item.js';
import { roomExpressions, roomInvariants } from './implementations/room.js';
import { customWallItemComponents, wallItemInvariants } from './implementations/wall-item.js';
import { customWallComponents, wallExpressions, wallInvariants } from './implementations/wall.js';
import { migrateState } from './migrations/index.js';
const adminViolationExpressions = adminInvariantBuilder.buildViolationExpressions();
export const adminDomainFactory = adminDomainBuilder.withExpressions(adminViolationExpressions).withMigrate(migrateAdminState).build();
const violationExpressions = invariantBuilder.withInvariants(roomInvariants).withInvariants(wallInvariants).withInvariants(wallItemInvariants).buildViolationExpressions();
const createDomain = domainBuilder.withExpressions(applianceExpressions).withExpressions(cabinetExpressions).withExpressions(cornerFillerExpressions).withExpressions(grillExpressions).withExpressions(partExpressions).withExpressions(roomExpressions).withExpressions(roomItemExpressions).withExpressions(wallExpressions).withExpressions(violationExpressions).withMigrate(migrateState).build();
const resources = new ResourceBuilder().addLink({
    type: 'ConfigurationLink',
    name: 'ownerLink'
}).addLink({
    type: 'ConfigurationLink',
    name: 'readRevisionLink'
}).addPdf({
    type: 'Pdf',
    name: 'userPdf',
    s3Key: `userPdf`
}).addClientGeneratedImage({
    type: 'Image',
    name: 'imagefull',
    s3Key: `imagefull`,
    clientGenerated: true
}).addClientGeneratedImage({
    type: 'Image',
    name: 'imagewalla',
    s3Key: `imagewalla`,
    clientGenerated: true
}).addClientGeneratedImage({
    type: 'Image',
    name: 'imagewallb',
    s3Key: `imagewallb`,
    clientGenerated: true
}).addClientGeneratedImage({
    type: 'Image',
    name: 'imagewallc',
    s3Key: `imagewallc`,
    clientGenerated: true
}).build();
export const configuratorBuilder = generatedConfiguratorBuilder.withComponentOptics(customWallComponents).withComponentOptics(customWallItemComponents).withDomainFactory(createDomain).withAdminDomainFactory(adminDomainFactory).withResources(resources);
export * as ApplicationTypes from './__generated/application-types.js';
export * as EnhancedDomain from './__generated/enhanced-model.js';
export * as Model from './__generated/model/index.js';
export * as AdminEnhancedDomain from './__generated/admin-enhanced-model.js';
export * as AdminModel from './__generated/admin-model/index.js';
export { getBottomWallStackId, getTopWallStackId, getCountertopWallStackId } from './implementations/wall.js';
export { createPresets } from './__generated/presets.js';
export { createAdminPresets } from './__generated/admin-presets.js';
export { attachComponent, createRecipe } from './__generated/implementation.js';
export { attachAdminComponent, createAdminRecipe } from './__generated/admin-implementation.js';
export * from './other/index.js';
export * from './data/cabinets.js';
export * from './data/appliances.js';
export * from './data/pricing.js';
export * from './util/round.js';
export * from './util/not-empty.js';
export * from './util/auth.js';
export * from './other/shipping-api.js';
export * from './other/shipping-api.types.js';
export * from './other/shipping-api.errors.js';

//# sourceMappingURL=index.js.map